export const DB = {
  OPENAI_API_KEY: 'openai_api_key',
};

export default {
  DB,
};
